<template>
  <label
    :for="id"
    :class="[disabled ? 'cursor-default' : 'cursor-pointer']"
    role="button"
    tabindex="-1"
    :style="`--transform: ${transform}`"
    @click.exact.left="$emit('click')"
    @click.shift="clearColor"
  >
    <input
      v-if="!disabled"
      :id="id"
      ref="colorPickerRef"
      v-model="pickerModel"
      type="color"
      class="cursor-pointer opacity-0 absolute"
      tabindex="-1"
    />
    <slot />
  </label>
</template>

<script lang="ts" setup>
const props = defineProps({
  defaultColor: {
    type: String,
    default: () => '#000000',
  },
  modelValue: {
    type: [String, null] as PropType<string | null>,
    default: () => '',
  },
  resettable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isPickerActive: {
    type: Boolean,
    default: false,
  },
  transform: {
    type: String,
    default: '',
  },
})
const emit = defineEmits(['update:modelValue', 'click'])

const id = useId()
const colorPickerRef = ref<HTMLElement | null>(null)

const pickerModel = computed({
  get() {
    return props.modelValue || props.defaultColor
  },
  set(v) {
    emit('update:modelValue', v || props.defaultColor)
  },
})

watch(
  () => props.isPickerActive,
  newValue => {
    setTimeout(() => {
      if (newValue && colorPickerRef.value) {
        colorPickerRef.value.click()
      }
    }, 0)
  },
)

function clearColor(event: Event) {
  event.preventDefault()
  if (!props.resettable) return
  pickerModel.value = ''
}
</script>

<style scoped>
input[type='color'] {
  transform: var(--transform);
}
</style>
